import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=17d7bbf8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports